import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router";
import { logout } from "../../store/common";
import { RingLoader } from "react-spinners";

const NavProfile = ({ ozName, logout, isLoading }) => {
  return (
    <div className="header__account">
      <RingLoader color={"#fff"} loading={isLoading} size={20} />
      {!isLoading && (
        <React.Fragment>
          {ozName || ""}
          <Link
            to="#"
            className="header__account__exit"
            onClick={() => logout()}
          >
            <i className="fa fa-fw fa-sign-out" />
          </Link>
        </React.Fragment>
      )}
    </div>
  );
};

NavProfile.propTypes = {
  ozName: PropTypes.string,
  logout: PropTypes.func,
  isLoading: PropTypes.bool
};

const mapStateToProps = ({ common }) => ({
  ozName:
    common.oz.first_name && common.oz.last_name
      ? `${common.oz.first_name} ${common.oz.last_name}`
      : null,
  isLoading: common.commonLoading
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavProfile);



// WEBPACK FOOTER //
// ./src/molecules/containers/NavProfile.js